import { Alert as JoyAlert, Box, styled, Typography } from '@mui/joy';
import { SxProps } from '@mui/joy/styles/types';

import { NotificationPosition } from 'core/enums';

interface IProps {
  showNotification?: boolean;
  notificationPosition?: NotificationPosition;
  fullWidth?: boolean;
  style?;
}

const getStyleByPosition = (position: NotificationPosition) => {
  switch (position) {
    case NotificationPosition.FORM:
    case NotificationPosition.DRAWER:
      return {
        position: 'relative',
        top: 0,
      };
    default:
      return {
        position: 'fixed',
        top: 63,
        zIndex: 9999,
      };
  }
};

const propsToSkip: PropertyKey[] = [
  'showNotification',
  'notificationPosition',
  'fullWidth',
  'style',
];
const shouldForwardProp = (propName: PropertyKey) => !propsToSkip.includes(propName);

export const Wrapper = styled(Box, { shouldForwardProp })<IProps>(
  ({ showNotification, notificationPosition, style }) => ({
    zIndex: 99,
    display: showNotification ? 'flex' : 'none',
    justifyContent: 'center',
    width: '100%',
    pointerEvents: 'none',

    ...getStyleByPosition(notificationPosition),

    ...style,
  })
);

export const Alert = styled(JoyAlert, { shouldForwardProp })<IProps>(({ fullWidth }) => ({
  width: fullWidth ? '100%' : '478px',
  padding: '6px 16px',
  alignItems: 'flex-start',
  borderRadius: 4,

  '& .MuiAlert-startDecorator': {
    marginTop: 10,
  },

  '& .MuiAlert-endDecorator': {
    '& .MuiButton-root': {
      borderRadius: 4,
      marginRight: '-10px',

      '& .MuiButton-endDecorator': {
        width: 12,
      },
    },
  },
}));

export const loadingIconStyle: SxProps = {
  ['--_root-size']: '17px',
  margin: '2px',
};

export const ContentWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  padding: '10px 0',
});

export const Title = styled(Typography)({
  fontSize: 16,
  fontWeight: 400,
  color: 'inherit',
});

export const Message = styled(Box)({
  fontSize: 14,
  fontWeight: 400,
  color: 'inherit',
  overflowWrap: 'anywhere',
});
